export const serviceProviders = [
  // Elétrica
  {
    id: 'sp-1',
    name: 'João Silva - Eletricista Profissional',
    slug: 'joao-silva-eletricista',
    description: 'Mais de 15 anos de experiência em instalações elétricas residenciais e comerciais. Especializado em automação residencial e energia solar.',
    category_id: 'sc-1',
    category_name: 'Elétrica',
    city: 'São Paulo',
    state: 'SP',
    country: 'BR',
    profile_image: 'https://randomuser.me/api/portraits/men/32.jpg',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ',
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.9,
    reviews_count: 127,
    total_contracts: 342,
    phone: '(11) 98765-4321',
    email: 'joao.silva@email.com',
    whatsapp: '5511987654321',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sp-2',
    name: 'Maria Santos - Elétrica e Automação',
    slug: 'maria-santos-eletrica',
    description: 'Engenheira eletricista com 10 anos de experiência. Especializada em projetos de iluminação e smart home.',
    category_id: 'sc-1',
    category_name: 'Elétrica',
    city: 'Rio de Janeiro',
    state: 'RJ',
    country: 'BR',
    profile_image: 'https://randomuser.me/api/portraits/women/44.jpg',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.8,
    reviews_count: 95,
    total_contracts: 218,
    phone: '(21) 97654-3210',
    email: 'maria.santos@email.com',
    whatsapp: '5521976543210',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  
  // Encanamento
  {
    id: 'sp-3',
    name: 'Pedro Costa - Encanador Especializado',
    slug: 'pedro-costa-encanador',
    description: 'Especialista em reparos hidráulicos e instalações completas. Atendimento rápido e eficiente.',
    category_id: 'sc-2',
    category_name: 'Encanamento e Hidráulica',
    city: 'Belo Horizonte',
    state: 'MG',
    country: 'BR',
    profile_image: 'https://randomuser.me/api/portraits/men/52.jpg',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ',
      'https://www.youtube.com/embed/dQw4w9WgXcQ',
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.7,
    reviews_count: 143,
    total_contracts: 389,
    phone: '(31) 98888-7777',
    email: 'pedro.costa@email.com',
    whatsapp: '5531988887777',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sp-4',
    name: 'Ana Lima - Hidráulica Residencial',
    slug: 'ana-lima-hidraulica',
    description: '8 anos de experiência em manutenção preventiva e corretiva. Trabalho limpo e garantido.',
    category_id: 'sc-2',
    category_name: 'Encanamento e Hidráulica',
    city: 'São Paulo',
    state: 'SP',
    country: 'BR',
    profile_image: 'https://randomuser.me/api/portraits/women/65.jpg',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.6,
    reviews_count: 78,
    total_contracts: 156,
    phone: '(11) 97777-6666',
    email: 'ana.lima@email.com',
    whatsapp: '5511977776666',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  
  // Jardinagem
  {
    id: 'sp-5',
    name: 'Carlos Oliveira - Paisagismo Premium',
    slug: 'carlos-oliveira-paisagismo',
    description: 'Paisagista profissional com projetos personalizados. Transformo seu jardim em um oásis.',
    category_id: 'sc-3',
    category_name: 'Jardinagem e Paisagismo',
    city: 'Curitiba',
    state: 'PR',
    country: 'BR',
    profile_image: 'https://randomuser.me/api/portraits/men/75.jpg',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ',
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.9,
    reviews_count: 156,
    total_contracts: 278,
    phone: '(41) 99999-8888',
    email: 'carlos.oliveira@email.com',
    whatsapp: '5541999998888',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sp-6',
    name: 'Fernanda Rocha - Jardinagem e Manutenção',
    slug: 'fernanda-rocha-jardinagem',
    description: 'Serviços de jardinagem, poda e manutenção de áreas verdes. Trabalho com amor e dedicação.',
    category_id: 'sc-3',
    category_name: 'Jardinagem e Paisagismo',
    city: 'Porto Alegre',
    state: 'RS',
    country: 'BR',
    profile_image: 'https://randomuser.me/api/portraits/women/32.jpg',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.8,
    reviews_count: 92,
    total_contracts: 187,
    phone: '(51) 98888-9999',
    email: 'fernanda.rocha@email.com',
    whatsapp: '5551988889999',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  
  // Limpeza
  {
    id: 'sp-7',
    name: 'Limpeza Total - Equipe Especializada',
    slug: 'limpeza-total',
    description: 'Empresa de limpeza com equipe treinada. Limpeza residencial, comercial e pós-obra.',
    category_id: 'sc-4',
    category_name: 'Limpeza e Conservação',
    city: 'São Paulo',
    state: 'SP',
    country: 'BR',
    profile_image: 'https://via.placeholder.com/200/4A90E2/ffffff?text=LT',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.5,
    reviews_count: 234,
    total_contracts: 567,
    phone: '(11) 3333-4444',
    email: 'contato@limpezatotal.com',
    whatsapp: '5511933334444',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  
  // Pintura
  {
    id: 'sp-8',
    name: 'Roberto Mendes - Pintor Profissional',
    slug: 'roberto-mendes-pintor',
    description: '20 anos de experiência em pintura residencial e comercial. Acabamento impecável.',
    category_id: 'sc-5',
    category_name: 'Pintura',
    city: 'Brasília',
    state: 'DF',
    country: 'BR',
    profile_image: 'https://randomuser.me/api/portraits/men/45.jpg',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ',
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.7,
    reviews_count: 165,
    total_contracts: 423,
    phone: '(61) 98765-1234',
    email: 'roberto.mendes@email.com',
    whatsapp: '5561987651234',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  
  // Marcenaria
  {
    id: 'sp-9',
    name: 'Marcenaria Silva - Móveis sob Medida',
    slug: 'marcenaria-silva',
    description: 'Móveis planejados de alta qualidade. Projetos personalizados para sua casa ou escritório.',
    category_id: 'sc-6',
    category_name: 'Marcenaria',
    city: 'Salvador',
    state: 'BA',
    country: 'BR',
    profile_image: 'https://via.placeholder.com/200/8B4513/ffffff?text=MS',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.8,
    reviews_count: 87,
    total_contracts: 145,
    phone: '(71) 99876-5432',
    email: 'contato@marcenariasilva.com',
    whatsapp: '5571998765432',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'sp-10',
    name: 'José Ferreira - Carpintaria e Marcenaria',
    slug: 'jose-ferreira-marcenaria',
    description: 'Carpinteiro e marceneiro com 12 anos de experiência. Trabalhos artesanais e sob medida.',
    category_id: 'sc-6',
    category_name: 'Marcenaria',
    city: 'Recife',
    state: 'PE',
    country: 'BR',
    profile_image: 'https://randomuser.me/api/portraits/men/68.jpg',
    videos: [
      'https://www.youtube.com/embed/dQw4w9WgXcQ',
      'https://www.youtube.com/embed/dQw4w9WgXcQ'
    ],
    average_rating: 4.6,
    reviews_count: 73,
    total_contracts: 129,
    phone: '(81) 98765-4321',
    email: 'jose.ferreira@email.com',
    whatsapp: '5581987654321',
    is_active: true,
    verified: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];
